import service from "@/api/service";
import { GetResponse } from "@/api/stamp-shop/response";

/**
 * スタンプカード機能有効店舗情報取得APIをコールします。
 *
 * @return GetResponse
 */
export async function get() {
  const response = await service.post("/get-stamp-shop");
  return response.data as GetResponse;
}
